import { Aspect } from '@teambit/harmony';

export const GlobalConfigAspect = Aspect.create({
  id: 'teambit.harmony/global-config',
  dependencies: [],
});

export default GlobalConfigAspect;
